// ========= START: src/components/SettingsScreen.js (New File) =========
import React from 'react';

function SettingsScreen({ settings, onSettingsChange, onBack }) {

  // Handles changes for any slider
  const handleSliderChange = (e) => {
    const { name, value } = e.target;
    onSettingsChange(prevSettings => ({
      ...prevSettings,
      [name]: parseFloat(value), // name will be 'bgvVolume' or 'sfxVolume'
    }));
  };

  return (
    <div className="settings-screen">
      <div className="settings-panel">
        <h2 className="settings-title">Settings</h2>
        
        <div className="volume-slider-container">
          <label htmlFor="bgmVolume">🎵 Background Music</label>
          <input
            type="range"
            id="bgmVolume"
            name="bgmVolume"
            min="0"
            max="1"
            step="0.01"
            value={settings.bgmVolume}
            onChange={handleSliderChange}
            className="volume-slider"
          />
          <span>{Math.round(settings.bgmVolume * 100)}%</span>
        </div>

        <div className="volume-slider-container">
          <label htmlFor="sfxVolume">🔊 Sound Effects</label>
          <input
            type="range"
            id="sfxVolume"
            name="sfxVolume"
            min="0"
            max="1"
            step="0.01"
            value={settings.sfxVolume}
            onChange={handleSliderChange}
            className="volume-slider"
          />
          <span>{Math.round(settings.sfxVolume * 100)}%</span>
        </div>

        {/* The "Back to Menu" button has been removed from here. The header button handles navigation. */}
      </div>
    </div>
  );
}

export default SettingsScreen;
// ========= END: src/components/SettingsScreen.js (New File) =========